<template>
  <div>
    <selectNetworkAsset ref="selectNetworkAsset" v-on:selectNetworkAssetComplete="selectNetworkAssetComplete"></selectNetworkAsset>
    <Modal
      v-model="execModal"
      :title="title"
      :mask-closable="false"
      @on-cancel="execModalCancel"
      width="400">
      <Form ref="execForm" :model="execForm" :label-width="110" :rules="execRule">
        <!--<Alert v-show="execForm.default_certify" show-icon>使用目标网络设备绑定的第一个凭证</Alert>-->
        <!--<FormItem label="用户凭证">-->
          <!--<Select v-model="execForm.certificate" :disabled="execForm.default_certify" placeholder="请选择目标网络设备上存在的用户凭证">-->
            <!--<Option v-for="item in allCertificateList" :value="item.id" :key="item.id">{{ item.name }}</Option>-->
          <!--</Select>-->
        <!--</FormItem>-->
        <!--<FormItem label="默认凭证" prop="default_certify">-->
          <!--<i-switch v-model="execForm.default_certify">-->
            <!--<span slot="open">是</span>-->
            <!--<span slot="close">否</span>-->
          <!--</i-switch>-->
        <!--</FormItem>-->
        <FormItem :label="'目标网络设备(' + waitExecServerLength + ')'">
          <Button type="default" icon="ios-desktop-outline" @click="openSelectNetworkAssetModal" v-if="!waitExecServerLength" class="w-100 align-left">选择目标网络设备</Button>
          <a v-on:click="openSelectNetworkAssetModal" v-else style="display:block">继续选择 </a>
          <Tag color="primary" v-for="(value, key, index) in waitExecServer" :key="'wait_network_' + index" v-if="value">{{ key }}</Tag>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" :loading="execIng" style="margin-right: 8px" @click="execOk">执行校验</Button>
        <Button @click="execModal = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { configStartExamine } from '@/api/network'
import selectNetworkAsset from './select-network-asset'

export default {
  name: 'start-examine',
  components: {
    selectNetworkAsset
  },
  data () {
    return {
      data: {},
      title: '配置校验',
      execModal: false,
      execIng: false,
      allCertificateList: [],
      execForm: {
        default_certify: false,
        certificate: ''
      },
      execRule: {
      },
      waitExecServer: {},
      waitExecServerLength: 0
    }
  },
  methods: {
    // 打开执行Modal
    openModal (data) {
      this.title = '策略名: ' + data.name
      this.data = data
      // this.getAllCertificate()
      this.execModal = true
    },
    // 关闭执行Modal
    execModalCancel () {
      // this.execForm.default_certify = false
      // this.execForm.certificate = ''
      this.waitExecServer = {}
      this.waitExecServerLength = 0
    },
    // 获取所有凭证列表
    // getAllCertificate () {
    //   getNetworkAllCertificate().then(res => {
    //     this.allCertificateList = res.data
    //   })
    // },
    // 打开设备选择Modal
    openSelectNetworkAssetModal () {
      this.$refs.selectNetworkAsset.openSelectNetworkAssetModal({}, this.waitExecServer)
    },
    // 选择设备完成回调
    selectNetworkAssetComplete (server, length) {
      this.waitExecServer = server
      this.waitExecServerLength = length
    },
    // 开始执行校验
    execOk () {
      // let assetIds = []
      // for (let i in this.waitExecServer) {
      //   if (this.waitExecServer[i]) {
      //     assetIds.push(this.waitExecServer[i])
      //   }
      // }
      let reqData = {
        id: this.data.id,
        assets: this.waitExecServer
        // certificate: this.execForm.certificate,
        // default_certify: this.execForm.default_certify
      }
      this.execIng = true
      configStartExamine(reqData).then(res => {
        let result = res.data
        this.execIng = false
        this.execModal = false
        this.$emit('execComplete')
        this.$Notice.success({
          title: '操作成功！',
          desc: result.data
        })
      }).catch(res => {
        this.execIng = false
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
